import { render, staticRenderFns } from "./individual_answer_result.vue?vue&type=template&id=20d4ee3c&scoped=true"
import script from "./individual_answer_result.vue?vue&type=script&lang=js"
export * from "./individual_answer_result.vue?vue&type=script&lang=js"
import style0 from "./individual_answer_result.vue?vue&type=style&index=0&id=20d4ee3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4ee3c",
  null
  
)

export default component.exports